export default "__VITE_ASSET__YRRwrowJ__"